import React from 'react';
import Router from './Router';
import { Provider } from 'react-redux';
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import reducer from './store/reducers/index';
import thunkMiddleware from 'redux-thunk';
import state from './store/state';
import { message } from 'antd';
import './app.less';

const store = createStore(reducer, state, applyMiddleware(thunkMiddleware));
message.config({
  // top: 100,
  // duration: 1,
  maxCount: 1,
  rtl: false,
  // prefixCls: 'my-message',
});

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Router />
      </Provider>
    </div>
  );
}

export default App;